import { z } from 'zod';

export const PER_PAGE = 24;

export const SEARCH_CATEGORIES = ['jigsaw-puzzles', 'puzzle-accessories', 'art-craft-kits'];

const _FILTER_ATTRIBUTE_TYPE = z.enum(['checkboxes']);

export type _FILTER_ATTRIBUTE_TYPES = z.infer<typeof _FILTER_ATTRIBUTE_TYPE>;

// Category-specific filter attributes
export const FILTER_ATTRIBUTES_BY_CATEGORY: Record<
  string,
  Record<string, { widget: _FILTER_ATTRIBUTE_TYPES }>
> = {
  'jigsaw-puzzles': {
    'puzzle-piece-count': {
      widget: 'checkboxes',
    },
    'puzzle-publisher': {
      widget: 'checkboxes',
    },
    'puzzle-artist': {
      widget: 'checkboxes',
    },
    'puzzle-series': {
      widget: 'checkboxes',
    },
  },
  'puzzle-accessories': {
    'puzzle-piece-count': {
      widget: 'checkboxes',
    },
    'puzzle-publisher': {
      widget: 'checkboxes',
    },
  },
  'art-craft-kits': {
    'puzzle-publisher': {
      widget: 'checkboxes',
    },
  },
};

// Default filter attributes - combines all attributes from all categories
export const DEFAULT_FILTER_ATTRIBUTES: Record<string, { widget: _FILTER_ATTRIBUTE_TYPES }> =
  Object.values(FILTER_ATTRIBUTES_BY_CATEGORY).reduce(
    (acc, categoryAttrs) => ({ ...acc, ...categoryAttrs }),
    {}
  );

// Helper function to get filter attributes for a category
export function getFilterAttributesForCategory(
  categorySlug?: string
): Record<string, { widget: _FILTER_ATTRIBUTE_TYPES }> {
  if (!categorySlug) {
    return DEFAULT_FILTER_ATTRIBUTES;
  }

  return FILTER_ATTRIBUTES_BY_CATEGORY[categorySlug] || {};
}
